export const CAKE_PRODUCT_TYPE_ID = 1;
export const CAKE_SLUG = "cake";
export const GIFTS_PRODUCT_TYPE_ID = 16;
export const GIFTS_SLUG = "gift-hampers";
export const QUICK_PICKS_PRODUCT_TYPE_ID = 11;
export const MOST_LOVED_GIFTS_COLLECTION_ID = 12;
export const HAND_MADE_IN_INDIA_COLLECTION_ID = 19;
export const GIFTS_FOR_HER_COLLECTION_ID = 5;
export const HOME_TOP_GIFTS_COLLECTION_IDS = [18, 17, 19, 16];
export const PERSONAL_CURATION_COLLECTION_IDS = [30, 31, 32, 36, 15, 34];
export const ANNIVERSARY_COLLECTION_ID = 49;
export const THANK_YOU_COLLECTION_ID = 50;
export const BEST_GIFTS_AND_CAKES_COLLECTION_ID = 5;
export const THE_DIWALI_FAVOURITES_COLLECTION_ID = 53;
export const MEANINGFUL_DIWALI_COLLECTION_ID = 7;
